import { toast } from "vue-sonner";
import router from "@/router";
import { CONTACT_OVERVIEW_ROUTE, BUCKETS_ROUTE } from "@/router/routes";
import type {
  BucketAutoCreatedPayload,
  BucketPromptManualPayload,
  LinkedInConnectionAcceptedPayload,
} from "@/dtos/BucketWebhook.dto";

/**
 * Show notification for LinkedIn connection accepted
 */
export function showLinkedInConnectionNotification(
  payload: LinkedInConnectionAcceptedPayload["payload"]
): void {
  const contactName = payload.userFullName || "Contact";

  toast.success("LinkedIn Connection Accepted", {
    description: `${contactName} accepted your LinkedIn connection request`,
    duration: 5000,
    action: {
      label: "View Contact",
      onClick: () => {
        router.push({
          name: CONTACT_OVERVIEW_ROUTE,
          params: { id: payload.contactId },
        });
      },
    },
  });
}

/**
 * Show notification for bucket auto-created
 */
export function showBucketAutoCreatedNotification(payload: BucketAutoCreatedPayload): void {
  const eventTypeMessages = {
    email_opened: "Email engagement detected",
    email_clicked: "Email link clicked",
    linkedin_connection: "LinkedIn connection accepted",
    whatsapp_message_read: "WhatsApp message read",
    whatsapp_message: "WhatsApp reply received",
    sms_received: "SMS reply received",
  };

  const message = eventTypeMessages[payload.eventType] || "Engagement detected";

  toast.info("Task Created Automatically", {
    description: `${message} - Task created automatically`,
    duration: 5000,
    action: {
      label: "View Task",
      onClick: () => {
        router.push({
          name: BUCKETS_ROUTE,
          params: { bucket: payload.bucketId },
        });
      },
    },
  });
}

/**
 * Format call duration for display
 */
export function formatCallDuration(seconds: number | null): string {
  if (!seconds) return "N/A";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
}

/**
 * Get event type icon
 */
export function getEventTypeIcon(eventType: string): string {
  switch (eventType) {
    case "email_opened":
    case "email_clicked":
      return "mdi:email-check";
    case "linkedin_connection":
      return "mdi:linkedin";
    case "whatsapp_message_read":
    case "whatsapp_message":
      return "mdi:whatsapp";
    case "sms_received":
      return "mdi:message-text";
    default:
      return "mdi:check-circle";
  }
}
